import React from 'react';
import StripeCard from "./stripeCard";
import StripeIdeal from "./stripeIdeal";
import StripeBancontact from "./stripeBancontact";

const Stripe = (props) => {
    const render = () => {

        if (!!props.props.stripeData.clientSecretIdeal) {
            return (
                <StripeIdeal
                    clientSecretIdeal={props.props.stripeData.clientSecretIdeal}
                />)
        }

        if (!!props.props.stripeData.clientSecretBancontact) {
            return (
                <StripeBancontact
                    clientSecretBancontact={props.props.stripeData.clientSecretBancontact}
                />
            )
        }

        return (
            <StripeCard
                clientSecretSaveCard={props.props.stripeData.clientSecretSaveCard}
                clientSecretNotSaveCard={props.props.stripeData.clientSecretNotSaveCard}
                formReference={props.formReference}
            />);
    }

    return (
        render()
    )
}

export default Stripe;


// WEBPACK FOOTER //
// ./src/containers/Checkout/Stripe/index.js